<template>
  <div :class="$style['pt-hospital-form']" v-loading="detail_loading">
    <pt-hospital-with-data :isEdit="isEdit" :userLogin="userLogin" ref="form" @submitLoading="submitLoading"
      @detailLoading="detailLoading"></pt-hospital-with-data>
    <div>
      <el-button type="primary" @click="submit" :loading="loading">保存</el-button>
    </div>
  </div>
</template>

<script>
import PtHospitalWithData from './withData'
// 组件class前缀
export default {
  name: 'pt-hospital-form',
  components: {
    PtHospitalWithData
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    userLogin: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      detail_loading: false
    }
  },
  methods: {
    detailLoading (val) {
      this.detailLoading = val
    },
    submitLoading (val) {
      this.loading = val
    },
    submit () {
      this.$refs.form.submit()
    },
    cancel () {
      history.go(-1)
    }
  }
}

</script>

<style module lang="less">
  /* 已启用css module， template中请使用$style.className添加class */
  /* 务必遵循css BEM原则 */

</style>
